import React from "react";

export function CheckIcon() {
  return <i className="fa-regular fa-circle-check"></i>;
}
